import React from 'react';
import { translate } from '../../Services/translation';
import { useDispatch } from 'react-redux';
import { setActiveTab } from '../../Actions/Search.action';
import styled from 'styled-components';
import { getColor } from '../../styling/mixins/colors';
import { fontFamilyBold, text } from '../../styling/mixins/typography';

interface NavigationItemProps {
  active: boolean;
}

const StyledNavigationItem = styled.li<NavigationItemProps>`
  padding: 0.8rem 0rem;
  cursor: pointer;
  color: ${(props) =>
    props.active ? getColor('grey', 900) : getColor('grey', 500)};
  border-bottom: 1px solid
    ${(props) => (props.active ? getColor('grey', 900) : 'transparent')};
  white-space: nowrap;
  span {
    ${text('medium')};
  }
  .bold {
    ${fontFamilyBold}
  }
`;

const SearchNavigationItem = ({ resultKey, quantity, active }) => {
  const dispatch = useDispatch();

  return (
    <StyledNavigationItem
      active={active}
      onClick={() => dispatch(setActiveTab(resultKey))}
    >
      <span className="bold">
        {translate(`quicksearchheader.${resultKey}`)}
      </span>
      <span> {'(' + quantity + ')'}</span>
    </StyledNavigationItem>
  );
};

export default SearchNavigationItem;
